import { isBusiness, isConsumer } from 'owa-session-store';
import { isNonPrivateCloud } from './isNonPrivateCloud';

export const isPublicCloudConsumerUser = () => isNonPrivateCloud() && isConsumer();
export const isPublicCloudBusinessUser = () => isNonPrivateCloud() && isBusiness();
